import { vars } from '@croquiscom-pvt/zds/tokens';
import { format } from 'date-fns';

import { numberWithCommas } from '@common/utils';

import { gradeColorJson } from '../constants/benefit';
import { GetUserMembership_pdp_user_base_info_pdp_user_membership as Membership } from '../graphql/pdp-user-membership_types.2';
import { GetUserBenefitInfo_pdp_user_base_info_pdp_max_user_benefit_issuable_mileage_promotion as IssuableMileagePromotion } from '../graphql/user-benefit-info_types.2';
import { Message } from '../types';

export function getMileageRewardMessage() {
  const getMileageTitle = (reward: number): Message => {
    return {
      sections: [
        {
          type: 'fixed',
          text: `마일리지 최대`,
        },
        {
          type: 'fixed',
          text: ` ${numberWithCommas(reward)}M`,
          style: { fontWeight: 500 },
        },
        {
          type: 'ellipsis',
          text: ' 적립',
        },
      ],
    };
  };

  const getPromotionMessage = (promotion: IssuableMileagePromotion): Message => {
    const mileagePromotionEndDateUTC = new Date(promotion?.date_end ?? 0);
    const mileagePromotionEndDateKST = new Date(
      mileagePromotionEndDateUTC.setHours(mileagePromotionEndDateUTC.getHours() + 9),
    );

    return {
      sections: [
        {
          type: 'ellipsis',
          text: promotion.title,
        },
        {
          type: 'fixed',
          text: `추가 적립(${promotion.rate}%) ${numberWithCommas(promotion?.amount ?? 0)}M (~${format(mileagePromotionEndDateKST, 'MM.dd')})`,
        },
      ],
    };
  };

  const getMembershipMessage = (additionalRate: number, pdpUserMembership: Membership): Message => {
    const additionalRateMessage = additionalRate ? `+추가 ${additionalRate}%` : '';

    return {
      sections: [
        {
          type: 'ellipsis',
          text: '멤버십 적립',
        },
        {
          type: 'fixed',
          text: '(',
        },
        {
          type: 'fixed',
          text: `${pdpUserMembership.grade} ${pdpUserMembership.mileage_reward.rate}%${additionalRateMessage}`,

          style: {
            color: gradeColorJson[pdpUserMembership.grade],
          },
        },
        {
          type: 'fixed',
          text: ')',
        },
        {
          type: 'fixed',
          text: ` ${numberWithCommas(pdpUserMembership.mileage_reward?.amount ?? 0)}M`,
        },
      ],
    };
  };

  const getNonmemberMembershipMessage = (rate: number, amount: number, onClick: () => void): Message => {
    return {
      sections: [
        {
          type: 'underline',
          text: '로그인',
          onClick,
        },
        {
          type: 'normal',
          text: ` 시`,
        },
        {
          type: 'normal',
          text: ` 최대 ${rate}%`,
          style: {
            color: vars.color.yellow400,
          },
        },
        {
          type: 'normal',
          text: ` 마일리지 적립 ${numberWithCommas(amount)}M`,
        },
      ],
    };
  };

  const getReviewBonusMessage = (maximumReviewBonus: number): Message => {
    return {
      sections: [
        {
          type: 'normal',
          text: `리뷰 작성 시 최대 ${numberWithCommas(maximumReviewBonus)}M`,
        },
      ],
    };
  };

  return {
    getMileageTitle,
    getPromotionMessage,
    getMembershipMessage,
    getNonmemberMembershipMessage,
    getReviewBonusMessage,
  };
}
